import { render, staticRenderFns } from "./AskForLeave.vue?vue&type=template&id=b896d96c&scoped=true&"
import script from "./AskForLeave.vue?vue&type=script&lang=js&"
export * from "./AskForLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b896d96c",
  null
  
)

export default component.exports